import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { PENDING, IDLE } from "const"
import { MtMailTemplate } from "server/models"
import { useInput, StateType } from "client/utils"
import {
    StoreType,
    MailTemplateValidation,
    SaveMailTemplate,
    closeModal,
    setMailTemplateEdit,
    setMailTemplateReloadList,
    setMailTemplateReloadEdit,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Textarea,
    Input,
    CKEditor,
    Feedback,
    Button,
    SpinnerIcon,
} from "client/components"

interface EditTemplateProps {
    template: MtMailTemplate
}

let isMounted: boolean

const Form = ({
    template,
}: EditTemplateProps) => {
    const modals = useSelector((state: StoreType) => state.system.modals)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [description, setDescription] = useInput(template.description)
    const [subject, setSubject] = useInput(template.subject)

    const [content, setContent] = useState(template.content)
    const [validation, setValidation] = useState<MailTemplateValidation>(null)

    const [saveState, setSaveState] = useState<StateType>(IDLE)
    const [applyState, setApplyState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    const onClose = () => {
        if (isMounted && modals.length) dispatch(closeModal())
    }

    const onSave = (mode: number) => {
        if (mode === 1) setSaveState(PENDING)
        if (mode === 2) setApplyState(PENDING)

        const newTemplateData: MtMailTemplate = {
            ...template,
            description,
            subject,
            content,
        }

        SaveMailTemplate(newTemplateData, lang)
        .then((res) => {
            if (isMounted) {
                setValidation(res.validation)
                setSaveState(IDLE)
                setApplyState(IDLE)
            }
            if (res.validation) return

            dispatch(setMailTemplateReloadList(false))
            setTimeout(() => {
                dispatch(setMailTemplateReloadList(true))
            }, 0)

            if (mode === 1) onClose()
            if (mode === 2) {
                dispatch(setMailTemplateEdit(newTemplateData))
                dispatch(setMailTemplateReloadEdit(false))
                setTimeout(() => {
                    dispatch(setMailTemplateReloadEdit(true))
                }, 0)
            }
        })
    }

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.description}</Label>
                        <Textarea value={description} onChange={setDescription} />
                        <Feedback>{validation && validation.description}</Feedback>
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.subject}</Label>
                        <Input type="text" value={subject} onChange={setSubject} />
                        <Feedback>{validation && validation.subject}</Feedback>
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.content}</Label>
                        <CKEditor
                            data={content}
                            onChange={setContent}
                        />
                        <Feedback>{validation && validation.content}</Feedback>
                    </FormGroup>
                </Col>
                <Col xs={12}>
                    <Button variant="success" row onClick={() => onSave(1)}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.save}
                    </Button>
                    <Button variant="success" row onClick={() => onSave(2)}>
                        {applyState === PENDING ? <SpinnerIcon /> : lang.apply}
                    </Button>
                    <Button row onClick={onClose}>{lang.cancel}</Button>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
